import { call, put } from 'redux-saga/effects'

import AddressActions from '../Redux/AddressRedux'

export function* getAddresses(api, { payload }) {
    const response = yield call(api.addresses.getAutocompleteAddress, payload.query)
    if (response) {
        yield put(AddressActions.getAddressesSuccess(response))
    } else {
        yield put(AddressActions.getAddressesFailure(response))
    }
}
